module.exports = __webpack_public_path__ + "static/img/free_amount.0b86608.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/join/free_amount.png
// module id = KErZ
// module chunks = 3